import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { DarkModeToggle } from "../ui";

export function Confidentialite() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 text-gray-900 dark:text-white">
      <div className="absolute top-4 right-4 z-20 flex items-center gap-4">
        <DarkModeToggle />
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          <ArrowLeft size={18} />
          {t("legal.back")}
        </Link>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-8">{t("legal.confidentiality")}</h1>
        <div className="prose prose-slate dark:prose-invert max-w-none space-y-4 text-gray-600 dark:text-slate-300">
          <p>
            La présente politique de confidentialité décrit comment Régie Connect collecte, utilise et protège
            les données personnelles des utilisateurs, dans le respect du Règlement général sur la protection
            des données (RGPD).
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Responsable du traitement</h2>
          <p>
            [À compléter : identité du responsable du traitement, contact DPO le cas échéant.]
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Données collectées</h2>
          <p>
            Nous collectons les données nécessaires au fonctionnement du service : identité (nom, email),
            données de connexion, dossiers clients et données métier (stock, planification). Les données sont
            hébergées dans l&apos;Union européenne.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Finalités et bases légales</h2>
          <p>
            Les données sont traitées pour la fourniture du service, la facturation et le support. Vous disposez
            d&apos;un droit d&apos;accès, de rectification, d&apos;effacement et à la portabilité de vos données,
            ainsi que du droit de réclamation auprès d&apos;une autorité de contrôle.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Durée de conservation</h2>
          <p>
            Les données sont conservées pendant la durée du contrat et selon les obligations légales. À la
            résiliation, vous pouvez demander un export de vos données (portabilité).
          </p>
          <p className="mt-8 text-sm text-gray-500 dark:text-slate-400">
            [Texte à adapter avec un conseil juridique pour votre activité.]
          </p>
        </div>
      </div>
    </div>
  );
}
